enum STEPPER {
  ZER0 = 0,
  ONE = 1,
  TWO = 2,
}

export default STEPPER;
